/* Cabinet Screws - PDP rich content behaviour.
   GENERATED by _gql/golive/build_rich.py from
   mockups/pdp-v2/index.html lines 3377-3533.
   Self-guards on #rc-global and data-rc-init, so it is inert on
   every page that does not render the section. */
(function () {
  'use strict';
  var root = document.getElementById('rc-global');
  if (!root || root.dataset.rcInit === '1') return;
  root.dataset.rcInit = '1';

  var reduceMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- lazy backgrounds, fetched ~1.5 viewports ahead ---- */
  var bgEls = Array.prototype.slice.call(root.querySelectorAll('[data-bg]'));
  var applyBg = function (el) {
    var u = el.getAttribute('data-bg');
    if (u) el.style.backgroundImage = "url('" + u + "')";
    el.removeAttribute('data-bg');
  };
  if ('IntersectionObserver' in window) {
    var bgio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { applyBg(e.target); bgio.unobserve(e.target); }
      });
    }, { rootMargin: '150% 0px' });
    bgEls.forEach(function (el) { bgio.observe(el); });
  } else { bgEls.forEach(applyBg); }

  /* ---- visibility gating (auto-advance only while on screen) ---- */
  var visIO = null;
  if ('IntersectionObserver' in window) {
    visIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        e.target.classList.toggle('is-vis', e.isIntersecting);
      });
    }, { threshold: 0 });
  }

  /* ---- carousel ---- */
  var track = root.querySelector('[data-rc-track]');
  var dotsEl = root.querySelector('[data-rc-dots]');
  var carWrap = root.querySelector('[data-rc-car]');
  var prevBtn = root.querySelector('.rc-arrow--prev');
  var nextBtn = root.querySelector('.rc-arrow--next');
  var auto = null;

  if (track && dotsEl) {
    var cards = Array.prototype.slice.call(track.children);
    var cw = function () {
      return cards[0].getBoundingClientRect().width + 20;   /* CMS: gap 20 */
    };
    var slide = function (d) {
      track.scrollBy({ left: d * cw(), behavior: 'smooth' });
    };

    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rc-dot';
      b.setAttribute('aria-label', 'Go to card ' + (i + 1));
      b.addEventListener('click', function () {
        track.scrollTo({ left: i * cw(), behavior: 'smooth' });
      });
      dotsEl.appendChild(b);
    });
    var dots = Array.prototype.slice.call(dotsEl.children);

    var sync = function () {
      var i = Math.min(cards.length - 1,
                       Math.round(track.scrollLeft / cw()));
      dots.forEach(function (d, j) {
        d.classList.toggle('rc-dot--on', j === i);
      });
      if (prevBtn) prevBtn.toggleAttribute('disabled', track.scrollLeft < 10);
      if (nextBtn) {
        nextBtn.toggleAttribute('disabled',
          track.scrollLeft > track.scrollWidth - track.clientWidth - 10);
      }
    };
    var tick = false;
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () { sync(); tick = false; });
    });
    sync();

    if (prevBtn) prevBtn.addEventListener('click', function () { slide(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { slide(1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { slide(1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { slide(-1); e.preventDefault(); }
    });

    var down = false, startX = 0, startL = 0;
    track.addEventListener('pointerdown', function (e) {
      down = true; track.classList.add('is-drag');
      startX = e.pageX; startL = track.scrollLeft;
    });
    window.addEventListener('pointerup', function () {
      down = false; track.classList.remove('is-drag');
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      track.scrollLeft = startL - (e.pageX - startX);
    });

    if (!reduceMotion) {
      if (visIO && carWrap) visIO.observe(carWrap);
      auto = setInterval(function () {
        if (document.hidden) return;
        if (visIO && carWrap && !carWrap.classList.contains('is-vis')) return;
        if (track.scrollLeft > track.scrollWidth - track.clientWidth - 10) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else { slide(1); }
      }, 5000);
      var killAuto = function () {
        if (auto) { clearInterval(auto); auto = null; }
      };
      if (carWrap) carWrap.addEventListener('mouseenter', killAuto);
      track.addEventListener('pointerdown', killAuto, { once: true });
    }
  }

  /* ---- scroll reveals ---- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  root.querySelectorAll('.rc-reveal').forEach(function (el) {
    io.observe(el);
  });

  /* ---- parallax (transform-based, iOS-safe) ---- */
  var plx = Array.prototype.slice.call(root.querySelectorAll('[data-plx]'));
  if (plx.length && !reduceMotion) {
    var par = function () {
      var wh = window.innerHeight;
      plx.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > wh) return;
        var p = (r.top + r.height / 2 - wh / 2) / wh;
        el.style.transform =
          'translateY(' + (p * el.dataset.plx * wh * -1).toFixed(1) + 'px)';
      });
    };
    var pt = false;
    window.addEventListener('scroll', function () {
      if (pt) return;
      pt = true;
      requestAnimationFrame(function () { par(); pt = false; });
    }, { passive: true });
    par();
  }
})();